import ForcastReportAction from "../actions/forcastReportAction";

const ForcastReportReducer = (state = { isForcastAccuracyLoading: false }, action) => {
    switch (action.type) {
        case ForcastReportAction.FORCAST_ACCURACY_ANALYTICS_REQUEST:
            return {
                ...state,
                isForcastAccuracyLoading: true
            };
        case ForcastReportAction.FORCAST_ACCURACY_ANALYTICS_SUCCESSFUL:
            return {
                ...state,
                isForcastAccuracyLoading: false,
                forcastAccuracy: action.data.data
            };
        case ForcastReportAction.FORCAST_ACCURACY_ANALYTICS_FAILED:
            return {
                ...state,
                errorMessage: {},
                isForcastAccuracyLoading: false
            };

        // forcastaccuracy v2
        case ForcastReportAction.FORCAST_ACCURACY_ANALYTICS_LATEST_REQUEST:
            return {
                ...state,
                isForcastAccuracyLoading: true
            };
        case ForcastReportAction.FORCAST_ACCURACY_ANALYTICS_LATEST_SUCCESSFUL:
            return {
                ...state,
                isForcastAccuracyLoading: false,
                forcastAccuracy: action.data.data
            };
        case ForcastReportAction.FORCAST_ACCURACY_ANALYTICS_LATEST_FAILED:
            return {
                ...state,
                errorMessage: {},
                isForcastAccuracyLoading: false
            };

        //human intervention
        case ForcastReportAction.FORCAST_ACCURACY_ANALYTICS_HUMAN_LATEST_REQUEST:
            return {
                ...state,
                isForcastAccuracyLoading: true
            };
        case ForcastReportAction.FORCAST_ACCURACY_ANALYTICS_HUMAN_LATEST_SUCCESSFUL:
            return {
                ...state,
                isForcastAccuracyLoading: false,
                forcastAccuracy: action.data.data
            };
        case ForcastReportAction.FORCAST_ACCURACY_ANALYTICS_HUMAN_LATEST_FAILED:
            return {
                ...state,
                errorMessage: {},
                isForcastAccuracyLoading: false
            };
        //
        default:
            return {
                ...state
            };
        //   break;
    }
};

export default ForcastReportReducer;
